{
  "id": 39,
  "location": "paris",
  "difficulty": "normal",
  "moves": 19,
  "kinds": 6,
  "goals": [
    { "type": "stain" },
    { "type": "collect", "kind": "macaron", "count": 20 }
  ],
  "stars": [3620, 4810],
  "board": [
    ". . . ~. ~. . . .",
    ". . . ~. ~. . . .",
    ". . . ~. ~. . . .",
    "~. ~. ~. ~. ~. ~. ~. ~.",
    "~. ~. ~. ~. ~. ~. ~. ~.",
    ". . . ~. ~. . . .",
    ". . . ~. ~. . . .",
    ". . . ~. ~. . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.659, "movesLeft": 5.2, "closeLosses": 0.311, "target": 0.68 }
}
